import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import React from 'react';
import './i18n/config'; // Initialize i18n before rendering
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';
const PRELOAD_ERROR_RELOAD_KEY = 'karia-vite-preload-error-reloaded-at';

if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();

    const lastReloadAt = Number(window.sessionStorage.getItem(PRELOAD_ERROR_RELOAD_KEY) || 0);
    if (Date.now() - lastReloadAt < 30000) return;

    window.sessionStorage.setItem(PRELOAD_ERROR_RELOAD_KEY, String(Date.now()));
    window.location.reload();
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {recaptchaSiteKey ? (
      <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
        <App />
      </GoogleReCaptchaProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);
